//constants
import {
  BASE_GUTTER_SPACE,
  DWEB_PRIMARY_HEADER_HEIGHT,
  DWEB_SECONDARY_HEADER_HEIGHT,
  PROMO_BANNER_HEIGHT,
} from 'shared/styles/base';
export const getContainerTop = (isSubMenuVisible: boolean) => {
  const containerTop = isSubMenuVisible
    ? BASE_GUTTER_SPACE +
      PROMO_BANNER_HEIGHT +
      DWEB_PRIMARY_HEADER_HEIGHT +
      DWEB_SECONDARY_HEADER_HEIGHT
    : BASE_GUTTER_SPACE + PROMO_BANNER_HEIGHT + DWEB_PRIMARY_HEADER_HEIGHT;

  return containerTop;
};
